import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class EditUserComponent implements OnInit {
  respObject: any;
  userData:any;
  respPeer: any;
  peerData: any;
  fileType="";
  oldEmail = "";
  email="";
  username="";
  oldUsername="";
  	oldPassword =""
	password="";
	repassword="";
	oldCompany="";
	company="1";
	oldCompanyName="";
	companyName="";
	role="1";
	oldRole="";
	comVisibility=true;
	userId="";
  constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { 
  	//private route: ActivatedRoute;
  }

  ngOnInit(){
  	const peerData = {}
  	this._rest.companyList(peerData).subscribe((res) => {
  		this.respPeer	=	res;
  		this.peerData	=	this.respPeer.details;
  		//console.log(JSON.stringify(this.respPeer));
  		
  	})
    this.route.params.forEach((params: Params) => {
      const data = {
        userId: params['id']
      }
      this.userId=params['id'];
      this._rest.getUserDetailsById(data).subscribe((res) => {
      console.log(JSON.stringify(res));
        this.respObject = res;
        this.userData=this.respObject.resp;
        this.username=this.userData[0].username;
        this.oldUsername= this.userData[0].username;
        this.email=this.userData[0].email;
        this.oldEmail= this.userData[0].email;
        this.role=this.userData[0].userRole;
        this.oldRole=this.userData[0].userRole;
        this.company=this.userData[0].companyId;
        this.oldCompany=this.userData[0].companyId;
        this.oldCompanyName=this.userData[0].companyName;
        this.companyName=this.userData[0].companyName;
        this.oldPassword=this.userData[0].password;
        if(this.role=="1"){
	  		this.comVisibility=true;
	  	} else {
	  		this.comVisibility=false;
	  	}
      });
      

    });
  	
  }
  ValidateEmail(mail){
	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)){
		return (true)
	} else {
		return (false)
	}
  }
  updateUser(field,oldValue){
  	const token = localStorage.getItem('userId');
  	
  	var errCounter = 0;
    if(field=="Username"){     
      //data.fieldName = "Email";
      if(this.username!=oldValue){
        if(this.username==""){
          errCounter++;
          alert("Please enter User ID.");
        }  else {
          var data0 = {"userId":this.userId,"modifiedBy":token,"username":this.username,"oldUsername":oldValue,"companyId":this.oldCompany,"fieldName":field};
          //console.log(data0);
          this._rest.updateUser(data0).subscribe((res) => {
            if(this.respObject.error==0){
            alert("User Updated Successfully.");
              window.location.reload();
          } else {
            alert(this.respObject.errorMessage);
          }
          });
        }
      } else {
        errCounter++;
        alert("No Modification required.");
      }
    } else if(field=="Email"){  		
  		//data.fieldName = "Email";
  		if(this.email!=oldValue){
  			if(this.email==""){
  				errCounter++;
  				alert("Please enter email address.");
  			} else if(!this.ValidateEmail(this.email)){
  				errCounter++;
  				alert("Please enter valid email address.");
  			} else {
  				var data = {"userId":this.userId,"modifiedBy":token,"email":this.email,"oldEmail":oldValue,"companyId":this.oldCompany,"fieldName":field};
  				console.log(data);
  				this._rest.updateUser(data).subscribe((res) => {
  					if(this.respObject.error==0){
						alert("User Updated Successfully.");
	  					window.location.reload();
					} else {
						alert(this.respObject.errorMessage);
					}
		  		});
  			}
  		} else {
  			errCounter++;
  			alert("No Modification required.");
  		}
  	} else if(field=="Password"){
  		if(this.password==""){
  			alert("Please enter the password");
  		} else if(this.repassword==""){
  			alert("Please enter the re-password");
  		} else if(this.password !=this.repassword){
  			alert("Both password field should be unique.");
  		} else {
  			var data1 = {"userId":this.userId,"modifiedBy":token,"password":this.password,"oldPassword":oldValue,"companyId":this.oldCompany,"fieldName":field,"oldCompanyName":this.oldCompanyName};
				console.log(data1);
				this._rest.updateUser(data1).subscribe((res) => {
					if(this.respObject.error==0){
					alert("User Updated Successfully.");
  					window.location.reload();
				} else {
					alert(this.respObject.errorMessage);
				}
	  		});
  		}
  	} else if(field=="Role"){
  		var data2 = {"userId":this.userId,"modifiedBy":token,"userRole":this.role,"olduserRole":oldValue,"oldCompanyId":this.oldCompany,"companyId":this.company,"fieldName":field};
  		if(this.role==this.oldRole && this.oldCompany==this.company){
  			alert("No Modification required.");
  			errCounter++;
  		} else if(this.role=="1"){
  			data2.companyId = "0";
  		}
  		if(errCounter==0){
			this._rest.updateUser(data2).subscribe((res) => {
				if(this.respObject.error==0){
					alert("User Updated Successfully.");
						window.location.reload();
				} else {
					alert(this.respObject.errorMessage);
				}
			});
  		}	
  	}
  }
  backfile(){
    this.router.navigate(['/analyst/viewfile']);
  }
  changeRole(){
  	if(this.role=="1"){
  		this.comVisibility=true;
  	} else {
  		this.comVisibility=false;
  	}
  }

}

